import apiService from './apiService';

export const getSites = async () => {
  try {
    const response = await apiService.get(`/sites`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sites:', error);
    throw error;
  }
};
